export { default, getStaticProps } from "app/error/page";
